// subscription-checkout.js

(function () {
  if (!window.supabase) {
    console.error("Supabase JS not loaded on subscription checkout page.");
    return;
  }
  if (!window.FEHME_SUPABASE_URL || !window.FEHME_SUPABASE_ANON_KEY) {
    console.error("FEHME Supabase config missing on subscription checkout page.");
    return;
  }

  var supabaseUrl = window.FEHME_SUPABASE_URL;
  var supabaseAnonKey = window.FEHME_SUPABASE_ANON_KEY;
  var client = window.supabase.createClient(supabaseUrl, supabaseAnonKey);
  window.fehmeSupabase = client;

  var currentSession = null;

  function setStatus(message) {
    var el = document.getElementById("subscription-status");
    if (el) {
      el.textContent = message;
    }
  }

  function setSignInEnabled(enabled) {
    var btn = document.getElementById("subscription-auth-submit");
    if (!btn) return;
    if (enabled) {
      btn.removeAttribute("disabled");
    } else {
      btn.setAttribute("disabled", "disabled");
    }
  }

  async function refreshSessionAndUi() {
    try {
      var result = await client.auth.getSession();
      if (result.error) {
        console.error("Supabase getSession error:", result.error);
        setStatus("Unable to check your membership status at the moment.");
        setSignInEnabled(true);
        return;
      }

      currentSession = result.data.session || null;

      if (!currentSession) {
        setStatus("Sign in to your FEHME account to purchase membership.");
        setSignInEnabled(true);
      } else {
        setStatus("Signed in. You can proceed to secure checkout.");
        setSignInEnabled(true);
      }
    } catch (err) {
      console.error("Unexpected getSession error:", err);
      setStatus("Unable to check your membership status at the moment.");
      setSignInEnabled(true);
    }
  }

  async function handleCheckoutClick() {
    if (!currentSession) {
      setStatus("Sign in to your FEHME account before continuing.");
      setSignInEnabled(true);
      return;
    }

    setStatus("Preparing your secure checkout.");
    setSignInEnabled(false);

    try {
      var sessionResult = await client.auth.getSession();
      var session = sessionResult.data && sessionResult.data.session;

      if (!session) {
        setStatus("Your session expired. Please sign in again.");
        await refreshSessionAndUi();
        return;
      }

      var accessToken = session.access_token;
      var edgeBase = supabaseUrl.replace(/\/$/, "") + "/functions/v1";

      var response = await fetch(edgeBase + "/create_checkout_session", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        console.error(
          "create_checkout_session error status:",
          response.status,
          await response.text()
        );
        setStatus("Could not start checkout. Try again in a moment.");
        setSignInEnabled(true);
        return;
      }

      var json = await response.json();
      if (!json || !json.url) {
        console.error("Unexpected response from create_checkout_session:", json);
        setStatus("Could not start checkout. Try again in a moment.");
        setSignInEnabled(true);
        return;
      }

      window.location.href = json.url;
    } catch (err) {
      console.error("Checkout error:", err);
      setStatus("Could not start checkout. Try again in a moment.");
      setSignInEnabled(true);
    }
  }

  async function handleAuthSubmit() {
    var emailInput = document.getElementById("subscription-email");
    var passwordInput = document.getElementById("subscription-password");
    if (!emailInput || !passwordInput) return;

    var email = (emailInput.value || "").trim();
    var password = passwordInput.value || "";

    if (!email || !password) {
      setStatus("Enter your email and password to continue.");
      return;
    }

    setStatus("Signing you in and preparing your membership purchase.");
    setSignInEnabled(false);

    try {
      var signInResult = await client.auth.signInWithPassword({
        email: email,
        password: password
      });

      if (signInResult.error) {
        console.error("Sign in error:", signInResult.error);
        var msg =
          signInResult.error.message || "Unable to sign you in with those details.";
        setStatus("Sign in failed: " + msg);
        setSignInEnabled(true);
        return;
      }

      currentSession = signInResult.data && signInResult.data.session;

      if (!currentSession) {
        setStatus("Could not establish a session. Try again in a moment.");
        setSignInEnabled(true);
        return;
      }

      // Successful sign in: go straight to checkout
      await handleCheckoutClick();
    } catch (err) {
      console.error("Unexpected auth error:", err);
      setStatus("Could not sign you in. Try again in a moment.");
      setSignInEnabled(true);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var signInButton = document.getElementById("subscription-auth-submit");

    if (signInButton) {
      signInButton.addEventListener("click", function (event) {
        event.preventDefault();
        handleAuthSubmit();
      });
    }

    refreshSessionAndUi().catch(function (err) {
      console.error("Initial session check failed:", err);
    });
  });
})();
